import { Component } from "react";
import { Link } from "react-router-dom";
import "../styles/hero.css";

class Hero extends Component {
  render() {
    return (
      <>
        <section
          className="py-5"
          style={{
            background: "linear-gradient(to top, #ffffff 0%, #edc6bb28 100%)",
          }}
        >
          <div className="container py-lg-5">
            <div className="row align-items-center g-4">
              <div className="col-lg-6">
                {/* 1. Dynamic Subtitle */}
                {this.props.subtitle && (
                  <span className="fw-medium text-dark d-block mb-3">
                    {this.props.subtitle}
                  </span>
                )}

                {/* 2. Dynamic Title */}
                <h1
                  className="display-4 fw-medium mb-4"
                  style={{ color: this.props.titleColor || "#b54a2e" }}
                >
                  {this.props.title}
                </h1>

                {/* 3. Dynamic Description */}
                <p className="lead text-secondary fw-normal mb-4 col-lg-10">
                  {this.props.description}
                </p>

                {/* 4. Dynamic Button Text and Link */}
                <Link
                  to={this.props.buttonLink || "/"}
                  className="btn btn-brand btn-lg px-4"
                  onClick={() => {
                    if (
                      this.props.buttonLink &&
                      this.props.buttonLink.includes("#")
                    ) {
                      const id = this.props.buttonLink.split("#")[1];
                      const element = document.getElementById(id);
                      if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                      }
                    }
                  }}
                >
                  {this.props.buttonText}
                </Link>
              </div>

              <div className="col-lg-6 text-center">
                {/* 5. Dynamic Image */}
                <img
                  src={this.props.imageSrc}
                  alt={this.props.imageAlt || "Hero image"}
                  className="hero-image rounded-4 mt-3"
                  style={this.props.imageStyle}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Hero;
